import { Dialog } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { DateTimePicker } from "../../core/components/dateTimePicker";
import { TextBox } from "../../core/components/textBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export const EditTicketLevel = (props: EditTicketLevelProps) => {
    const factory = ComponentHelper.createFactory();

    let dateTimeProps = factory.getDefaultDateTimePickerProps();
    dateTimeProps.value = props.agreedTargetDate;
    dateTimeProps.onChange = props.onAgreedTargetDateChanged;

    let textBoxProps = factory.getDefaultTextBoxProps();
    textBoxProps.value = props.agreedTargetComment || "";
    textBoxProps.onChange = props.onAgreedTargetCommentChanged;

    return (
        <>
            <FieldInstance label={props.translations["WebSMS.SLA.TicketLevel.AgreedTargetDate"]} noHover={true} >
                <DateTimePicker {...dateTimeProps} />
            </FieldInstance>
            <FieldInstance label={props.translations["WebSMS.SLA.TicketLevel.AgreedTargetComment"]} noHover={true}>
                <TextBox {...textBoxProps} />
            </FieldInstance>
        </>);
}

interface EditTicketLevelProps {
    translations: StringKeyDictionary<string>;
    agreedTargetDate?: Date;
    agreedTargetComment?: string;
    onAgreedTargetDateChanged(field: { model: string }, value: any, dataItem?: any);
    onAgreedTargetCommentChanged(field: { model: string }, value: any, dataItem?: any);
}